<template>
  <nav id="main-navbar" v-if="showNavbar" class="navbar is-fixed-top" role="navigation">
    <div class="navbar-brand">
      <router-link class="navbar-item" to="/" exact>
        <div class="brand-content">
          <div class="logo-container">
            <img src="/1200px-IIM_Bangalore_Logo.svg.png" alt="IIMB Logo" class="logo-image">
          </div>
          <div class="brand-text">
            <h1 class="brand-title">IIMB Faculty Recruitment</h1>
            <p class="brand-subtitle">Application Portal</p>
          </div>
        </div>
      </router-link>

      <div
        :class="{ 'is-active': showMobileNav }"
        class="navbar-burger burger"
        @click="toggleMobileNav"
        aria-label="menu"
        aria-expanded="false"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </div>
    </div>

    <div
      id="navMenu"
      :class="{ 'is-active': showMobileNav }"
      class="navbar-menu"
    >
      <div class="navbar-end">
        <div v-if="isLoggedIn" class="navbar-item">
          <div class="user-info">
            <b-icon icon="account-circle" size="is-medium" class="has-text-primary mr-2"></b-icon>
            <div class="user-details">
              <span class="has-text-weight-semibold">{{emailAddress}}</span>
              <br>
              <small class="has-text-success">Signed In</small>
            </div>
            <b-button 
              type="is-light" 
              size="is-small" 
              class="ml-3"
              @click="logout()">
              <b-icon icon="logout" size="is-small"></b-icon>
              <span>Sign Out</span>
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { get } from "vuex-pathify"
import jwt_decode from "jwt-decode"

export default {
  name: "Navbar",
  components: {},
  mixins: [],
  data() {
    return {
      showMobileNav: false,
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  computed: {
    showNavbar: get("ui/showNavbar"),
    isAuthenticated: get("account/isAuthenticated"),
    accessToken: get("account/accessToken"),
    emailAddress: get("account/emailAddress"),
    isLoggedIn() {
      // Check both authentication status and token validity
      if (!this.isAuthenticated || !this.accessToken) {
        return false;
      }
      
      try {
        // Decode and check token expiration
        const decoded = jwt_decode(this.accessToken);
        const now = Date.now().valueOf() / 1000;
        
        if (typeof decoded.exp !== 'undefined' && decoded.exp < now) {
          // Token has expired, logout user silently (don't show toast to avoid loops)
          this.$accountAPI.logout();
          return false;
        }
        
        return true;
      } catch (error) {
        // Invalid token, logout user silently
        this.$accountAPI.logout();
        return false;
      }
    }
  },
  methods: {
    logout() {
      this.$accountAPI.logout()
      this.$buefy.toast.open({
        duration: 3000,
        message: "Successfully signed out",
        position: "is-top",
        type: "is-success",
      })
      // Only navigate to login if not already there
      if (this.$router.currentRoute.path !== "/login") {
        this.$router.push("/login")
      }
    },
    toggleMobileNav() {
      this.showMobileNav = !this.showMobileNav
    },
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
nav#main-navbar {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-bottom: 2px solid #3273dc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  right: 0;
  left: 0;
  z-index: 30;
  height: 70px;
  transition: all 0.3s ease;

  .navbar-brand {
    min-height: 0;
    height: 70px;
    padding: 0 1.5rem;

    .navbar-item {
      padding: 0;
      height: 100%;
      display: flex;
      align-items: center;

      &:hover {
        background: transparent;
      }

      .brand-content {
        display: flex;
        align-items: center;
        gap: 1rem;

        .logo-container {
          .logo-image {
            height: 45px;
            width: auto;
            object-fit: contain;
          }
        }

        .brand-text {
          display: flex;
          flex-direction: column;
          line-height: 1.2;

          .brand-title {
            font-weight: 700;
            font-size: 1.25rem;
            color: #3273dc;
            margin: 0;
            line-height: 1.2;
          }

          .brand-subtitle {
            font-size: 0.8rem;
            color: #666;
            margin: 0;
            font-weight: 500;
          }
        }
      }
    }
  }

  .navbar-burger {
    height: 70px;
    width: 70px;
    border: none;
    background: transparent;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(50, 115, 220, 0.1);
    }

    span {
      background-color: #3273dc;
      height: 2px;
      width: 20px;
      transition: all 0.3s ease;
    }

    &.is-active {
      span {
        &:nth-child(1) {
          transform: rotate(45deg) translate(5px, 5px);
        }
        &:nth-child(2) {
          opacity: 0;
        }
        &:nth-child(3) {
          transform: rotate(-45deg) translate(7px, -6px);
        }
      }
    }
  }

  .navbar-menu {
    background: transparent;
    box-shadow: none;

    .navbar-end {
      .navbar-item {
        .user-info {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          padding: 0.5rem 1rem;
          border-radius: 8px;
          background: rgba(50, 115, 220, 0.05);
          border: 1px solid rgba(50, 115, 220, 0.1);

          .user-details {
            display: flex;
            flex-direction: column;
            line-height: 1.2;
          }
        }
      }
    }
  }
}

// Mobile responsive design
@media (max-width: 768px) {
  nav#main-navbar {
    .navbar-brand {
      padding: 0 1rem;

      .navbar-item {
        .brand-content {
          gap: 0.75rem;

          .brand-text {
            .brand-title {
              font-size: 1.1rem;
            }

            .brand-subtitle {
              font-size: 0.75rem;
            }
          }
        }
      }
    }

    .navbar-menu {
      &.is-active {
        background: white;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        border-top: 1px solid #e8e8e8;
      }

      .navbar-end {
        .navbar-item {
          .user-info {
            margin: 1rem;
            flex-direction: column;
            text-align: center;
            gap: 0.5rem;
          }
        }
      }
    }
  }
}
</style>
